<template>
  <div style="height: 100%">
    <div class="background" :style="sectionBackgroundStyle">
      <div class="overlay"></div>
    </div>
    <div class="login d-flex flex-column justify-center align-center">
      <v-card
        class="d-flex flex-column justify-center align-center pa-6 card-radius"
        elevation="0"
      >
        <h1 class="display-1 font-weight-light text-center ma-4">
          Your subscription has expired.
        </h1>
        <p>Thank you for using Spacepack.ph.</p>
        <p class="subtitle-2 text-center">
          Please contact the developers to extend your subscription.
        </p>
        <v-select
          v-if="userProperties.length"
          v-model="selectedProperty"
          :items="userProperties"
          label="Select Existing Property"
          hide-details
          append-inner-icon="mdi-home-city-outline"
          dense
          class="mt-4"
          @change="changeCurrentProperty"
        >
        </v-select>
        <div class="link"><a class="text-tiny" @click="logout">Log Out</a></div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedProperty: null,
      sectionBackgroundStyle: `background-image: url(${process.env.BASE_URL}images/cover_img_1.jpg); background-size:cover; background-position: center center;background-attachment:fixed;`
    }
  },
  computed: {
    userProperties() {
      return this.$store.getters['auth/getUser'].property_details.map(
        (prop) => {
          return {
            value: prop.propertyId,
            text: prop.propertyName
          }
        }
      )
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch('auth/doLogout')
      // this.$router.go()
      window.location.reload()
    },
    async changeCurrentProperty() {
      await this.$store
        .dispatch('auth/changeCurrentPropertyAction', {
          propertyId: this.selectedProperty
        })
        .then(() => {
          this.$router.replace('/dashboard')
        })
        .catch((err) => {
          if (err == 'EXPIRED_PROPERTY') {
            this.$root.$confirm({
              title: 'Expired Property',
              message: `The subscription of this property has expired. Please select a different property or contact the developers to extend your subscription`,
              reconfirmOnly: true,
              confirmText: 'Okay'
            })
          }
        })
    }
  }
}
</script>

<style scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60%;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.95;
  height: 100%;
  background: #662d91;
  background: -moz-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, #662d91),
    color-stop(100%, #798eea)
  );
  background: -webkit-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -ms-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: linear-gradient(135deg, #662d91 0%, #798eea 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#662d91', endColorstr='#798eea', GradientType=1 );
}
.login {
  /*background-image: `url(${process.env.BASE_URL}images/cover_img_1.jpg)`;*/
  height: 100%;
}
.v-card.card-radius {
  border-radius: 12px !important;
}
.v-form {
  width: 30vw;
}
.link {
  padding-top: 20px;
  text-align: center;
}
.link a {
  text-decoration: none;
  /*color: white;*/
  font-size: 20px;
}
.display-1 {
  letter-spacing: 0.5px;
  /*color: white;*/
}
.subtitle-2 {
  letter-spacing: 3px;
  /*color: white;*/
}
</style>
